import axios from 'axios';
import axiosInstance from '@/shared/api/axios';
import { env } from '@/shared/lib/env';
import type {
  ApiAuthLogoutBody,
  ApiAuthMeStaffResponse,
  ApiAuthStaffLoginPostBody,
  ApiAuthStaffLoginPostResponse,
} from '@/shared/types/api/auth';

export const apiAuthStaffLoginPost = async (
  body: ApiAuthStaffLoginPostBody,
): Promise<ApiAuthStaffLoginPostResponse> => {
  const { data } = await axios.post<ApiAuthStaffLoginPostResponse>(
    `${env.apiUrl}/auth/staff/login`,
    body,
    { headers: { 'Content-Type': 'application/json' } },
  );
  return data;
};

export const apiAuthLogoutPost = async (body: ApiAuthLogoutBody): Promise<void> => {
  await axiosInstance.post('/auth/logout', body);
};

export const apiAuthMeGet = async (): Promise<ApiAuthMeStaffResponse> => {
  const { data } = await axiosInstance.get<ApiAuthMeStaffResponse>('/auth/me');
  return data;
};
